import { useLocalSearchParams } from 'expo-router';

import { BoatRentalScreen } from '@/components/riviera/boat-rental-screen';

export { generateBoatRentalCityStaticParams as generateStaticParams } from '@/lib/detail/boat-rental-detail';

// One city's boat rentals, e.g. /en/boat-rental/cannes — the landing page for
// "boat rental cannes" searches. /[lang]/boats is the regional hub, so there is
// no /boat-rental index route. Only cities with enough boats are exported —
// see generateBoatRentalCityStaticParams.
export default function BoatRentalCityScreen() {
  const { city } = useLocalSearchParams<{ city: string }>();
  return <BoatRentalScreen cityId={city ?? ''} />;
}
